import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/developer/www/bazz.bet/bzfront/src/domains/providers/components/providers-view/index.tsx");
